import type { ReactNode } from "react";

// Checkbox-chip control for the firewall's access_modes arrays — used by the
// firewall entity forms via FormItem.render. Value in/out is string[] (the
// dataset layer JSON.stringify's it for the jsonb column); a loaded record
// may hand us the JSON string form, so both are accepted.
// FEATURE-20260716-sql-firewall-policy-editor

function toArray(v: unknown): string[] {
  if (Array.isArray(v)) return v.map(String);
  if (typeof v === "string" && v.trim().startsWith("[")) {
    try {
      return (JSON.parse(v) as unknown[]).map(String);
    } catch {
      return [];
    }
  }
  return [];
}

export function accessModesControl(
  value: unknown,
  onChange: (v: unknown) => void,
  allowed: readonly string[],
): ReactNode {
  const selected = new Set(toArray(value));
  const toggle = (mode: string) => {
    const next = new Set(selected);
    if (next.has(mode)) next.delete(mode);
    else next.add(mode);
    // Emit in the canonical (allowed-list) order so diffs are stable.
    onChange(allowed.filter((m) => next.has(m)));
  };
  return (
    <div className="fw-modes" style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
      {allowed.map((mode) => {
        const on = selected.has(mode);
        return (
          <button
            key={mode}
            type="button"
            onClick={() => toggle(mode)}
            aria-pressed={on}
            style={{
              padding: "2px 10px",
              borderRadius: "12px",
              border: "1px solid " + (on ? "var(--accent, #2563eb)" : "#8884"),
              background: on ? "var(--accent, #2563eb)" : "transparent",
              color: on ? "#fff" : "inherit",
              cursor: "pointer",
              font: "inherit",
              fontSize: "0.85em",
            }}
          >
            {mode}
          </button>
        );
      })}
    </div>
  );
}
